<template>
  <v-navigation-drawer
    v-model="showLeftMenu"
    class="navigation-menu"
    width="320"
    left
    fixed
    touchless
    clipped
  >
    <v-container class="pt-5 pl-5 pb-0">
      <v-btn
        fab
        x-small
        class="elevation-0 mt-1 mr-0"
        @click.stop="showLeftMenu = false"
        color="white"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-container>
    <v-list class="pt-2 mobile-contact-options">
      <v-list-item
        v-for="(item, index) in contactOptions"
        :key="index"
        class="mobile-contact-option"
      >
        <v-list-item-action>
          <a :href="item.link" class="normal-link mobile-contact-icon" target="_blank">
            <v-icon>{{ item.icon }}</v-icon>
          </a>
        </v-list-item-action>
        <v-list-item-title>
          <a :href="item.link" class="normal-link mobile-contact-text" target="_blank">
            {{ $i18n.t(item.title_translation) + (item.colon ? ':' : '') }}
            {{ item.title }}
          </a>
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="pt-9">
        <v-list-item-action>
        </v-list-item-action>
        <v-list-item-title style="color: white !important;">
          <b>{{ $i18n.t('mobile-contacts-menu-message') !== 'mobile-contacts-menu-message' ? $i18n.t('mobile-contacts-menu-message') : '' }}</b>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import sharedMethods from '../../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
import sharedComputed from '@/methods/sharedComputed'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'MobileLeftMenu',

  data () {
    return {
      showMenuId: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
  },

  methods: {
    ...sharedMethods,
  },
}
</script>

<style>
.mobile-contact-option {
  color: white !important;
  margin-top: 30px;
  padding-left: 25px;
}
.mobile-contact-options {
  margin-bottom: 15px;
}
.mobile-contact-icon i {
  color: white !important;
}
.mobile-contact-text {
  white-space: inherit !important;
  overflow: inherit !important;
}
</style>
